import {React, _, observer} from '@api';
import {HexPdf, SpecItemView, SpecLabelText, productCardStyles} from '@modules/pdf';
import {Image, Link, Text, View} from "@react-pdf/renderer";
import {nav} from '@stores'

import {buildImageUrl} from '@utils';
import {styled} from '@pdf'

const RootView = styled.View`
display:flex;
flex-direction: column;
`

const TitleText = styled.Text`
    flex-grow:0;
    flex-shrink:1;
    padding-right: 4px;
    margin: auto 0;
    font-family: Helvetica;
    font-size:   8pt;
    display:block;
    white-space: pre-wrap;
    overflow:hidden;
    text-overflow: ellipsis;
`

export class SpecItemPdf extends React.Component<{ hideImage?: boolean, spec, style?: any, textStyle?: any, imageStyle?: any, hexStyle?: any }> {
  static defaultProps = {
    hideImage: false
  }

  render() {
    let {props: {spec, style, textStyle, hexStyle, imageStyle, hideImage}} = this

    if (!spec) return null

    spec                                     = {
      ...spec,
      title:    _.trim(spec.title) || _.trim(spec.name) || '--',
      subtitle: _.trim(spec.subtitle1) || '--',
      images:   spec.images && spec.images.length ? [buildImageUrl(spec.imagesRaw || spec.images)] : [],
      blank:    false,
    }
    const {title, images, subtitle, id, hex} = spec

    return (
      <Link src={nav.urlForObject(spec)}>
        <RootView>
         {/* <SpecItemView style={style}>
            <SpecLabelText style={textStyle}>{specLibraryMap[specTitle]}</SpecLabelText>
          </SpecItemView>*/}
          <SpecItemView style={style}>
            {/*<SpecPdfImage spec={spec} />*/}

          {(!_.isEmpty(images) && !hideImage ? <Image src={_.first(images)} style={{...productCardStyles.specSwatch, ...productCardStyles.specImage, ...imageStyle}}/>
                              : !_.isEmpty(hex) ? <HexPdf key='hex' style={{...productCardStyles.specSwatch, ...productCardStyles.specHex, ...imageStyle, ...hexStyle}} hex={hex}/>
                                                : <View style={{...productCardStyles.specSwatch, ...productCardStyles.specImagePlaceholder, ...imageStyle}}/>)}

          <TitleText style={{marginLeft: hideImage ? 0 : 4, ...textStyle}}>{title}</TitleText>
          </SpecItemView>
        </RootView>
      </Link>
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/productCard/SpecItemPdf.tsx